/** @format */

import styled from "styled-components";
import { BaseColor } from "../../../theme/maps/Colors";
import { C, L } from "../../../theme/maps/StatiPresenze";
import { lineaOraria } from "../ViewPresenze/styles";

/** Stessa intestazione e pagina dei Turni e delle Presenze. */
export { Intestazione, Pagina } from "../ViewTurniSettimana/styles";

const TITOLO_SCHEDA = "#2F3A78";

/**
 * Home (variante B): striscia "Oggi", riga "Da gestire", "Chi c'è" a tutta larghezza, poi
 * contatori, richieste e documenti/comunicazioni. Stessi colori di stato di Turni e Presenze.
 */
export const HomeStile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${C.testo};

  .numeri {
    font-variant-numeric: tabular-nums;
  }
  .attenuato {
    color: ${C.testoSecondario};
  }

  /* ------------------------------------------------------------ schede */
  .scheda {
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 0;
    padding: 18px 20px;
    background: #fff;
    border: 1px solid ${C.linea};
    border-radius: 12px;
  }
  .testa {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 12px;
  }
  .testa h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    color: ${TITOLO_SCHEDA};
  }
  .testa .accanto {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 10px;
  }
  .collegamento {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13.5px;
    font-weight: 700;
    color: ${BaseColor};
  }
  .collegamento:hover {
    color: ${TITOLO_SCHEDA};
  }
  .vuoto {
    font-size: 13.5px;
    color: ${C.testoSecondario};
  }

  /* ------------------------------------------------------------ pillole */
  .pillola {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 22px;
    padding: 0 9px;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }
  .pillola.verde {
    background: ${C.inCorso.fondo};
    color: ${C.inCorso.testo};
  }
  .pillola.rosso {
    background: ${L.anomalia.fondo};
    color: ${L.anomalia.testo};
  }
  .pillola.ambra {
    background: ${L.avviso.fondo};
    color: ${L.avviso.testo};
  }
  .pillola.blu {
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
  }
  .pillola.grigio {
    background: #eceef3;
    color: #41475e;
  }
  .pillola.viola {
    background: ${L.straordinario.fondo};
    color: ${L.straordinario.testo};
  }
  .pillola.attesa {
    background: ${L.inAttesa.fondo};
    color: ${L.inAttesa.testo};
  }
  .pillola.piccola {
    height: 18px;
    padding: 0 7px;
    font-size: 11px;
  }
  .punto {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${C.inCorso.punto};
  }

  /* ------------------------------------------------------------ Oggi */
  .oggi {
    display: grid;
    grid-template-columns: minmax(220px, auto) minmax(280px, 1fr) auto;
    align-items: center;
    gap: 16px 24px;
    padding: 14px 20px;
    background: #fff;
    border: 1px solid ${C.linea};
    border-radius: 12px;
  }
  .oggi .stato {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .oggi .riga1 {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13.5px;
    font-weight: 700;
  }
  .oggi .riga1.verde {
    color: ${C.inCorso.testo};
  }
  .oggi .riga1.blu {
    color: ${C.daSvolgere.testo};
  }
  .oggi .riga1.rosso {
    color: ${C.anomalia.testo};
  }
  .oggi .riga1.grigio {
    color: #41475e;
  }
  .oggi .grande {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
  }
  .oggi .riga3 {
    font-size: 12.5px;
    color: ${C.testoSecondario};
  }
  .oggi .azioni {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
  }
  .oggi .azioni .nota {
    max-width: 260px;
    font-size: 12px;
    text-align: right;
    color: ${C.testoSecondario};
  }
  .oggi .assenza {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 44px;
    padding: 0 14px;
    border: 1px solid;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
  }
  .oggi .assenza .pallino {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  ${lineaOraria}
  .oggi .linea {
    height: 48px;
    border-radius: 8px;
    background-color: ${C.fondoTotali};
  }
  .oggi .linea .turno,
  .oggi .linea .permesso {
    top: 4px;
    bottom: 4px;
    padding: 2px 6px;
    font-size: 11px;
  }
  .oggi .linea .presenza {
    bottom: 7px;
    height: 20px;
    font-size: 11.5px;
  }
  .oggi .linea .giornata-intera {
    top: 8px;
    bottom: 8px;
  }
  .oggi .linea .adesso {
    position: absolute;
    top: -4px;
    bottom: -4px;
    z-index: 3;
    width: 2px;
    background: ${L.adesso};
  }
  .asse {
    position: relative;
    height: 14px;
    margin-top: 3px;
    font-size: 11px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .asse span {
    position: absolute;
    transform: translateX(-50%);
  }
  .asse span.prima {
    transform: none;
  }
  .asse span.ultima {
    transform: translateX(-100%);
  }
  .barra-turno {
    position: relative;
    height: 10px;
    overflow: hidden;
    border-radius: 5px;
    background: ${C.barra.traccia};
  }
  .barra-turno i {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    border-radius: 5px;
    background: #78c29d;
  }
  .estremi {
    display: flex;
    justify-content: space-between;
    margin-top: 3px;
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }

  @media (max-width: 1100px) {
    .oggi {
      grid-template-columns: minmax(0, 1fr);
    }
    .oggi .azioni {
      align-items: stretch;
    }
    .oggi .azioni .nota {
      max-width: none;
      text-align: left;
    }
  }

  /* ------------------------------------------------------------ Da gestire */
  .da-gestire {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
  .da-gestire .etichetta {
    margin-right: 4px;
    font-size: 13px;
    font-weight: 700;
    color: #41475e;
  }
  .da-gestire .etichetta .periodo {
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .voce {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 36px;
    padding: 0 12px 0 5px;
    border: 1px solid ${C.linea};
    border-radius: 18px;
    background: #fff;
    font-size: 13.5px;
    font-weight: 700;
    color: ${C.testo};
  }
  a.voce:hover {
    border-color: #a9b0d6;
    color: ${C.testo};
  }
  .voce .n {
    display: grid;
    place-items: center;
    min-width: 26px;
    height: 26px;
    padding: 0 7px;
    border-radius: 13px;
    font-size: 13px;
  }
  .voce.zero {
    color: ${C.testoSecondario};
  }
  .voce .n.blu {
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
  }
  .voce .n.rosso {
    background: ${L.anomalia.fondo};
    color: ${L.anomalia.testo};
  }
  .voce .n.ambra {
    background: ${L.avviso.fondo};
    color: ${L.avviso.testo};
  }
  .voce .n.grigio {
    background: #eceef3;
    color: #41475e;
  }
  .voce .periodo {
    font-weight: 600;
    color: ${C.testoSecondario};
  }

  /* ------------------------------------------------------------ Chi c'è */
  .filtri {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
  .filtri .gruppo {
    min-width: 220px;
    flex: 0 1 280px;
  }
  .filtri .ricerca {
    flex: 1 1 200px;
    max-width: 300px;
  }
  .stato-lettura {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .totali {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
  }
  .totale {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 10px 14px;
    border: 0;
    border-radius: 10px;
    font: inherit;
    text-align: left;
  }
  button.totale {
    cursor: pointer;
  }
  button.totale[aria-pressed="true"] {
    box-shadow: inset 0 0 0 2px currentColor;
  }
  .totale b {
    font-size: 24px;
    line-height: 1.15;
  }
  .totale span {
    font-size: 13px;
    font-weight: 700;
  }
  .totale.verde {
    background: ${C.inCorso.fondo};
    color: ${C.inCorso.testo};
  }
  .totale.blu {
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
  }
  .totale.viola {
    background: ${L.straordinario.fondo};
    color: ${L.straordinario.testo};
  }
  .totale.ambra {
    background: ${L.avviso.fondo};
    color: ${L.avviso.testo};
  }
  .totale.grigio {
    background: ${C.riposo.fondo};
    color: #41475e;
  }
  /* al massimo 3 reparti per riga */
  .tessere {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    align-items: start;
  }
  .tessera {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
    padding: 14px;
    border: 1px solid ${C.linea};
    border-radius: 12px;
    background: #fff;
  }
  .tessera.vuota {
    background: ${C.fondoTotali};
  }
  .tessera h3 {
    margin: 0;
  }
  .testa-tessera {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-height: 32px;
    margin: -4px 0;
    padding: 0;
    border: 0;
    background: transparent;
    font: inherit;
    text-align: left;
    color: ${C.testo};
    cursor: pointer;
  }
  .testa-tessera:focus-visible {
    outline: 2px solid ${BaseColor};
    outline-offset: 2px;
    border-radius: 6px;
  }
  .testa-tessera .freccia {
    flex-shrink: 0;
    font-size: 11px;
    color: ${C.testoSecondario};
    transition: transform 0.15s;
  }
  .tessera.chiusa .freccia {
    transform: rotate(-90deg);
  }
  .testa-tessera .nome-reparto {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .testa-tessera .conteggio {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 700;
    color: #41475e;
  }
  .carica-chi-ce {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .carica-chi-ce .messaggio {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 40px;
    font-size: 13.5px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .suggerimento {
    font-size: 12px;
    color: ${C.testoSecondario};
  }
  .barra {
    display: flex;
    height: 8px;
    overflow: hidden;
    border-radius: 4px;
    background: ${C.barra.traccia};
  }
  .barra i {
    display: block;
    height: 100%;
  }
  /* le prime 6 persone a vista, le altre scorrendo dentro la tessera */
  .scorrevole {
    position: relative;
  }
  .scorrevole::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 28px;
    background: linear-gradient(rgba(255, 255, 255, 0), #fff);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s;
  }
  .scorrevole.altro::after {
    opacity: 1;
  }
  .persone {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0 4px 0 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-width: thin;
    list-style: none;
  }
  .persone:focus-visible {
    outline: 2px solid ${BaseColor};
    outline-offset: 2px;
  }
  .persone li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 9px 0;
    border-top: 1px solid ${C.lineaLeggera};
  }
  .persone li:first-child {
    border-top: 0;
  }
  .persone .chi {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    padding-top: 5px;
  }
  /* nome intero: va a capo invece di troncarsi */
  .persone .nome {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 2px 6px;
    font-size: 13.5px;
    font-weight: 700;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }
  .turni-persona {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  .chip-turno {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 24px;
    padding: 0 8px;
    border: 1px solid;
    border-radius: 6px;
    font-size: 12.5px;
    font-weight: 700;
    white-space: nowrap;
  }
  .chip-turno .anticon {
    font-size: 11px;
  }
  .chip-turno .nota {
    font-weight: 600;
    opacity: 0.85;
  }
  .chip-turno .nota::before {
    content: "· ";
  }
  .chip-turno.in_corso {
    background: ${L.aperta.fondo};
    border-color: ${L.aperta.bordo};
    color: ${L.aperta.testo};
  }
  .chip-turno.timbrato {
    background: ${C.timbrato.fondo};
    border-color: ${C.timbrato.bordo};
    color: ${C.timbrato.testo};
  }
  .chip-turno.da_svolgere {
    background: ${C.daSvolgere.fondo};
    border-color: ${C.daSvolgere.bordo};
    color: ${C.daSvolgere.testo};
  }
  .chip-turno.non_timbrato {
    background: ${L.nonTimbrato.fondo};
    border-color: ${L.nonTimbrato.bordo};
    color: ${L.nonTimbrato.testo};
  }
  .chip-turno.straordinario {
    background: ${L.straordinario.fondo};
    border-color: ${L.straordinario.bordo};
    color: ${L.straordinario.testo};
  }
  .chip-turno.straordinario .punto {
    background: ${L.straordinario.testo};
  }
  .legenda {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 8px;
    margin-top: -4px;
  }
  .legenda .chip-turno {
    height: 22px;
    font-size: 12px;
    font-weight: 600;
  }
  .solo-lettori {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
  @media (max-width: 1100px) {
    .tessere {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  @media (max-width: 700px) {
    .tessere {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  @media (max-width: 760px) {
    .totali {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  /* ------------------------------------------------------------ settimana (senza Chi c'è) */
  .settimana {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .settimana li {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    min-height: 92px;
    padding: 10px;
    border: 1px solid ${C.linea};
    border-radius: 10px;
    background: #fff;
  }
  .settimana li.oggi-giorno {
    border-color: ${BaseColor};
    background: ${C.oggi};
    box-shadow: inset 0 -3px 0 ${BaseColor};
  }
  .settimana li.festa {
    background: ${C.festa.fondo};
  }
  .settimana .g {
    display: flex;
    align-items: baseline;
    gap: 5px;
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
    text-transform: capitalize;
  }
  .settimana .g b {
    font-size: 16px;
    color: ${C.testo};
  }
  .settimana li.oggi-giorno .g b {
    color: ${BaseColor};
  }
  .tc {
    display: block;
    overflow: hidden;
    padding: 3px 7px;
    border: 1px solid;
    border-radius: 7px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tc.da_svolgere {
    background: ${C.daSvolgere.fondo};
    border-color: ${C.daSvolgere.bordo};
    color: ${C.daSvolgere.testo};
  }
  .tc.in_corso {
    background: ${C.inCorso.fondo};
    border-color: ${C.inCorso.bordo};
    color: ${C.inCorso.testo};
  }
  .tc.timbrato,
  .tc.coperto {
    background: ${C.timbrato.fondo};
    border-color: ${C.timbrato.bordo};
    color: ${C.timbrato.testo};
  }
  .tc.mancata_timbratura {
    background: ${C.anomalia.fondo};
    border-color: ${C.anomalia.bordo};
    color: ${C.anomalia.testo};
  }
  .tc.non_lavorativo {
    background: ${C.riposo.fondo};
    border-color: #e3e5ec;
    color: ${C.riposo.testo};
  }
  .tc.giust.in-attesa {
    border-style: dashed;
  }

  @media (max-width: 900px) {
    .settimana {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  @media (max-width: 520px) {
    .settimana {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  /* ------------------------------------------------------------ riga in basso */
  .tre {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
    align-items: start;
  }
  .contatori {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }
  .contatore {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    padding: 10px 12px;
    border: 1px solid ${C.linea};
    border-radius: 10px;
  }
  .contatore .valore {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
  }
  .contatore .valore small {
    margin-left: 3px;
    font-size: 12.5px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .contatore .tacca {
    height: 4px;
    border-radius: 2px;
  }
  .contatore .nome {
    font-size: 12.5px;
    font-weight: 700;
    color: #41475e;
  }
  .elenco {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .elenco li {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 48px;
    padding: 7px 0;
    border-top: 1px solid ${C.lineaLeggera};
  }
  .elenco li:first-child {
    border-top: 0;
  }
  .elenco .colore {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    border-radius: 4px;
  }
  .elenco .testo {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
  }
  .elenco .titolo {
    overflow: hidden;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${C.testo};
  }
  .elenco .titolo.letto {
    font-weight: 600;
  }
  a.titolo:hover {
    color: ${TITOLO_SCHEDA};
    text-decoration: underline;
  }
  .elenco .sotto {
    font-size: 12.5px;
    color: ${C.testoSecondario};
  }
  .non-letto {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${BaseColor};
  }
  .letto-segno {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
  }
  .schede-mini {
    display: flex;
    gap: 4px;
    border-bottom: 1px solid #dde0e9;
  }
  .schede-mini button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    margin-bottom: -1px;
    padding: 0 10px;
    border: 0;
    border-bottom: 3px solid transparent;
    background: transparent;
    font: inherit;
    font-size: 14.5px;
    font-weight: 700;
    color: #4a5170;
    cursor: pointer;
  }
  .schede-mini button[aria-pressed="true"] {
    color: ${TITOLO_SCHEDA};
    border-bottom-color: ${BaseColor};
  }
  .schede-mini .c {
    display: inline-grid;
    place-items: center;
    min-width: 20px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9px;
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
    font-size: 12px;
  }
`;

/** Contenuto della finestra di timbratura (scelta del tipo, del turno e codice QR). */
export const TimbraturaStile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${C.testo};

  .passo {
    font-size: 13.5px;
    font-weight: 700;
    color: #41475e;
  }
  .tipi {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .tipo {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 40px;
    padding: 0 14px;
    border: 1px solid #d9d9d9;
    border-radius: 20px;
    background: #fff;
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    color: ${C.testo};
    cursor: pointer;
  }
  .tipo i {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .tipo[aria-pressed="true"] {
    border-color: ${C.testo};
    box-shadow: inset 0 0 0 1px ${C.testo};
  }
  .turni {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .turno-scelta {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 48px;
    padding: 0 14px;
    border: 1px solid ${C.daSvolgere.bordo};
    border-radius: 8px;
    background: #fff;
    font: inherit;
    font-size: 14.5px;
    font-weight: 700;
    color: ${C.daSvolgere.testo};
    text-align: left;
    cursor: pointer;
  }
  .turno-scelta:hover {
    border-color: ${BaseColor};
    background: ${C.oggi};
  }
  .turno-scelta .sede {
    margin-left: auto;
    font-size: 12.5px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .qr .conto {
    font-size: 13px;
    font-weight: 700;
    color: #41475e;
  }
  .qr .titolo {
    font-size: 16px;
    font-weight: 700;
  }
  .qr .nota {
    font-size: 12.5px;
    text-align: center;
    color: ${C.testoSecondario};
  }
`;
